const SCOPE = "dashboardRecords";
const ACTIONS = {
  getDiaryRevisionRecords: "getDiaryRevisionRecords",
  fetchDiaryDates: "fetchDiaryDates",
};
const MUTATIONS = {
  addNewRecord: "addNewRecord",
  setWorkContentModalRecord: "setWorkContentModalRecord",
  setValueRecord: "setValueRecord",
  setStatusEditable: "setStatusEditable",
  setDiaryRevisionRecords: "setDiaryRevisionRecords",
  setDiaries: "setDiaries",
  setLastDiaryId: "setLastDiaryId",
  setLatestEditAs: "setLatestEditAs",
  changeStatusFocus: "changeStatusFocus",
  changeStatusFocusCommons: "changeStatusFocusCommons",
  setDataHeaderSigns: "setDataHeaderSigns",
  setSitePatrolRecords: "setSitePatrolRecords",
  setSitePatrolCustomLabel: "setSitePatrolCustomLabel",
  setTempWorkRecord: "setTempWorkRecord",
  setDataInputWorkModal: "setDataInputWorkModal",
  updateWorkContentModalRecord: "updateWorkContentModalRecord",
  addQualificatedResponsibleField: "addQualificatedResponsibleField",
  removeQuanlificatedResponsible: "removeQuanlificatedResponsible",
  addUsedEquipmentField: "addUsedEquipmentField",
  removeUsedEquipmentField: "removeUsedEquipmentField",
  addSafetyInstructions: "addSafetyInstructions",
  removeSafetyInstructions: "removeSafetyInstructions",
  setUrlImage: "setUrlImage",
  setPresignedUrlImage: "setPresignedUrlImage",
  setObjectKeyImage: "setObjectKeyImage",
  deleteRecord: "deleteRecord",
  changePositionWorkDialog: "changePositionWorkDialog",
  recalculateRevision: "recalculateRevision",
  assignOrderPosition: "assignOrderPosition",
  resetState: "resetState",
  setDiaryDates: "setDiaryDates",
  mergeDiaryAfterConflict: "mergeDiaryAfterConflict",
  updateLoadedOriginalRowIds: "updateLoadedOriginalRowIds",
};
const GETTERS = {
  getDataHeader: `${SCOPE}/getDataHeader`,
  getSitePatrolRecords: `${SCOPE}/getSitePatrolRecords`,
  getAttachedImage: `${SCOPE}/getAttachedImage`,
  getAttachedPresignedUrl: `${SCOPE}/getAttachedPresignedUrl`,
  getSignRecords: `${SCOPE}/getSignRecords`,
  getStatusEditable: `${SCOPE}/getStatusEditable`,
  getDiaryRevisions: `${SCOPE}/getDiaryRevisions`,
  getInitRevisionsState: `${SCOPE}/getInitRevisionsState`,
  getDiaries: `${SCOPE}/getDiaries`,
  getTempWorkRecord: `${SCOPE}/getTempWorkRecord`,
  getOrderIdFreeze: `${SCOPE}/getOrderIdFreeze`,
  getLatestEditAs: `${SCOPE}/getLatestEditAs`,
  getDiaryDates: `${SCOPE}/getDiaryDates`,
  getPreviousDate: `${SCOPE}/getPreviousDate`,
  getNextDate: `${SCOPE}/getNextDate`,
  getCurrentRevision: `${SCOPE}/getCurrentRevision`,
  getLoadedOriginalRowIds: `${SCOPE}/getLoadedOriginalRowIds`,
};
const DISPATCH = {
  getDiaryRevisionRecords: `${SCOPE}/${ACTIONS.getDiaryRevisionRecords}`,
  fetchDiaryDates: `${SCOPE}/${ACTIONS.fetchDiaryDates}`,
};
const COMMIT = {
  addNewRecord: `${SCOPE}/${MUTATIONS.addNewRecord}`,
  setWorkContentModalRecord: `${SCOPE}/${MUTATIONS.setWorkContentModalRecord}`,
  setValueRecord: `${SCOPE}/${MUTATIONS.setValueRecord}`,
  setStatusEditable: `${SCOPE}/${MUTATIONS.setStatusEditable}`,
  setDiaryRevisionRecords: `${SCOPE}/${MUTATIONS.setDiaryRevisionRecords}`,
  setDiaries: `${SCOPE}/${MUTATIONS.setDiaries}`,
  setLastDiaryId: `${SCOPE}/${MUTATIONS.setLastDiaryId}`,
  setLatestEditAs: `${SCOPE}/${MUTATIONS.setLatestEditAs}`,
  changeStatusFocus: `${SCOPE}/${MUTATIONS.changeStatusFocus}`,
  changeStatusFocusCommons: `${SCOPE}/${MUTATIONS.changeStatusFocusCommons}`,
  setDataHeaderSigns: `${SCOPE}/${MUTATIONS.setDataHeaderSigns}`,
  setSitePatrolRecords: `${SCOPE}/${MUTATIONS.setSitePatrolRecords}`,
  setSitePatrolCustomLabel: `${SCOPE}/${MUTATIONS.setSitePatrolCustomLabel}`,
  setTempWorkRecord: `${SCOPE}/${MUTATIONS.setTempWorkRecord}`,
  setDataInputWorkModal: `${SCOPE}/${MUTATIONS.setDataInputWorkModal}`,
  updateWorkContentModalRecord: `${SCOPE}/${MUTATIONS.updateWorkContentModalRecord}`,
  addQualificatedResponsibleField: `${SCOPE}/${MUTATIONS.addQualificatedResponsibleField}`,
  removeQuanlificatedResponsible: `${SCOPE}/${MUTATIONS.removeQuanlificatedResponsible}`,
  addUsedEquipmentField: `${SCOPE}/${MUTATIONS.addUsedEquipmentField}`,
  removeUsedEquipmentField: `${SCOPE}/${MUTATIONS.removeUsedEquipmentField}`,
  addSafetyInstructions: `${SCOPE}/${MUTATIONS.addSafetyInstructions}`,
  removeSafetyInstructions: `${SCOPE}/${MUTATIONS.removeSafetyInstructions}`,
  setUrlImage: `${SCOPE}/${MUTATIONS.setUrlImage}`,
  setPresignedUrlImage: `${SCOPE}/${MUTATIONS.setPresignedUrlImage}`,
  setObjectKeyImage: `${SCOPE}/${MUTATIONS.setObjectKeyImage}`,
  deleteRecord: `${SCOPE}/${MUTATIONS.deleteRecord}`,
  changePositionWorkDialog: `${SCOPE}/${MUTATIONS.changePositionWorkDialog}`,
  recalculateRevision: `${SCOPE}/${MUTATIONS.recalculateRevision}`,
  assignOrderPosition: `${SCOPE}/${MUTATIONS.assignOrderPosition}`,
  resetState: `${SCOPE}/${MUTATIONS.resetState}`,
  setDiaryDates: `${SCOPE}/${MUTATIONS.setDiaryDates}`,
  mergeDiaryAfterConflict: `${SCOPE}/${MUTATIONS.mergeDiaryAfterConflict}`,
  updateLoadedOriginalRowIds: `${SCOPE}/${MUTATIONS.updateLoadedOriginalRowIds}`,
};
export default {
  ACTIONS, MUTATIONS, GETTERS, DISPATCH, COMMIT
};
